import Vue from "vue";
import i18n from "./i18n";
import App from "./App.vue";

Vue.config.productionTip = false;
Vue.config.devtools = false;

const defaultfilteryear = true;
const defaultfiltergroupids = "";
const defaultparentid = -1;
const defaultpagesize = 20;
const defautresultType = "Result";

const resourceindexelement = document.getElementById("sm-news-index");

const filteryear =
  resourceindexelement?.getAttribute("data-filteryear") == null
    ? defaultfilteryear
    : resourceindexelement.getAttribute("data-filteryear")?.toLowerCase() ===
      "true";
const filtergroupids =
  resourceindexelement?.getAttribute("data-filtergroupids") ??
  defaultfiltergroupids;

const resulttype =
  resourceindexelement?.getAttribute("data-resulttype") ?? defautresultType;

let parentid = defaultparentid;
const castparentid = Number(
  resourceindexelement?.getAttribute("data-parentid")
);
if (!isNaN(castparentid) && castparentid !== 0) parentid = castparentid;

let pagesize = defaultpagesize;
const castpagesize = Number(
  resourceindexelement?.getAttribute("data-pagesize")
);
if (!isNaN(castpagesize) && castpagesize !== 0) pagesize = castpagesize;

const title = resourceindexelement?.getAttribute("data-title");
const description = resourceindexelement?.getAttribute("data-description");
const key = resourceindexelement?.getAttribute("data-ocpApimSubscriptionKey");
const domain = resourceindexelement?.getAttribute("data-apidomain");
const  index = resourceindexelement?.getAttribute("data-searchindex");
new Vue({
  i18n,
  render: (h) =>
    h(App, {
      props: {
        filtergroupids: filtergroupids,
        filteryear: filteryear,
        parentid: parentid,
        pagesize: pagesize,
        title: title,
        description: description,
        resultType: resulttype,
        ocpApimSubscriptionKey: key,
        apidomain: domain,
        searchIndex: index

      },
    }),
}).$mount("#sm-news-index");
